import { useJobChangesRequest } from "../../apis/jobChanges/useJobChangesRequest";

export const useJobChangesHandlers = () => {
    const { setJobChanges, getJobChanges } = useJobChangesRequest();

    const setJobChangesHandler = async (payload: any, additionalHeaders?: { [k: string]: string }) => {
        const result = await setJobChanges(payload, additionalHeaders);
        return result;
    }

    const getJobChangesHandler = async () => {
        const result = await getJobChanges();
        return result;
    }

    return {
        setJobChangesHandler,
        getJobChangesHandler
    };
}
